import { loadAccessToken, resetAccessToken } from "../../pages/messenger/stores/authStore";

async function apiRequest(endpoint, params, data, method) {
  const url = new URL(`${process.env.REACT_APP_DEV_API_BASE}${endpoint}`);

  if (params) {
    url.search = new URLSearchParams(params).toString();
  }

  const headers = { "Content-Type": "application/json" };
  const authToken = await loadAccessToken();
  if (authToken) headers.Authorization = `Bearer ${authToken}`;

  const options = { method, headers };
  if (data) options.body = JSON.stringify(data);

  let response = await fetch(url, options);

  // 401: access token 만료 또는 invalid → resetAccessToken 후 loadAccessToken 다시 호출
  if (response.status === 401) {
    resetAccessToken();
    const newToken = await loadAccessToken();
    if (!newToken) {
      window.memberEntry?.openLogin?.();
      throw new Error("세션이 만료되었습니다. 다시 로그인해주세요.");
    }
    options.headers.Authorization = `Bearer ${newToken}`;
    response = await fetch(url, options);
  }

  if (!response.ok) {
    let message = `${endpoint} 에서 ${method} 요청 시 ${response.status} 에러 발생`;
    try {
      const body = await response.json();
      if (body && typeof body.error === "string" && body.error) message = body.error;
    } catch (error) {
      console.error(error);
    }
    throw new Error(message);
  }

  return response.json();
}

export function get(endpoint, params) {
  return apiRequest(endpoint, params, null, "GET");
}
export function post(endpoint, data) {
  return apiRequest(endpoint, null, data, "POST");
}
export function put(endpoint, data) {
  return apiRequest(endpoint, null, data, "PUT");
}
export function patch(endpoint, data) {
  return apiRequest(endpoint, null, data, "PATCH");
}
export function del(endpoint) {
  return apiRequest(endpoint, null, null, "DELETE");
}

export async function postFormData(endpoint, formData) {
  const url = new URL(`${process.env.REACT_APP_DEV_API_BASE}${endpoint}`);
  const headers = {};
  const authToken = await loadAccessToken();
  if (authToken) headers.Authorization = `Bearer ${authToken}`;
  const response = await fetch(url, { method: "POST", headers, body: formData });
  if (!response.ok) {
    let message = `${endpoint} 에서 POST 요청 시 ${response.status} 에러 발생`;
    try {
      const body = await response.json();
      if (body && typeof body.error === "string" && body.error) message = body.error;
    } catch (error) {
      console.error(error);
    }
    const err = new Error(message);
    err.status = response.status;
    throw err;
  }
  return response.json();
}

export async function postFormUrlEncoded(endpoint, data) {
  const response = await fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(data).toString(),
  });
  if (!response.ok) {
    let message = `${endpoint} 에서 POST 요청 시 ${response.status} 에러 발생`;
    try {
      const body = await response.json();
      if (body && typeof body.error === "string" && body.error) message = body.error;
    } catch (_) { /* body가 JSON이 아닌 경우 무시 */ }
    throw new Error(message);
  }
  return response.json();
}

export async function postNoBody(endpoint) {
  const url = new URL(`${process.env.REACT_APP_DEV_API_BASE}${endpoint}`);
  const headers = { "Content-Type": "application/json" };
  const authToken = await loadAccessToken();
  if (authToken) headers.Authorization = `Bearer ${authToken}`;
  const response = await fetch(url, { method: "POST", headers });
  if (!response.ok) {
    let message = `${endpoint} POST 요청 시 ${response.status} 에러 발생`;
    try {
      const body = await response.json();
      if (body && typeof body.error === "string" && body.error) message = body.error;
    } catch (error) {
      console.error(error);
    }
    throw new Error(message);
  }
}
